function Input(props) {
    const {
        id,
        type,
        name,
        placeholder,
        onChange,
        onKeyPress,
        Icon,
        value,
        optional,
        disabled,
        selectOptions,
        subLabel
    } = props;

    return (
        <div className="relative flex w-full flex-wrap items-stretch">
            <div className={"flex justify-between w-full"}>
                <label htmlFor={id} className="text-sm text-sm font-medium text-indigo-900 w-full">
                    {name}
                </label>
            </div>
            <span className={
                "z-10 h-full leading-snug absolute text-center bg-transparent rounded items-center " +
                "justify-center pl-2 "
                + (disabled && "opacity-50")
            }
                  style={{ paddingTop: 2.45 + 'rem' }}
            >
                {Icon}
            </span>

            {type === "select" ?
                <select
                    className={"mt-2 w-full px-3 py-2 relative bg-blue-gray-50 rounded-md focus:ring-primary-600 " +
                        "focus:border-primary-600 block w-full shadow-sm text-sm border-blue-gray-300 "
                        + (Icon && "pl-8 ")
                        + (disabled && "disabled:opacity-50")}
                    onChange={onChange ? e => onChange(e.target.value) : null}
                >
                    {selectOptions && selectOptions.map(({ value, text, selected }) => (
                        <option key={value} value={value} selected={selected ? "selected" : ""}>{text}</option>
                    ))}
                </select>
                :
                <input
                    className={
                        "mt-2 w-full px-3 py-2 relative bg-blue-gray-50 rounded-md focus:ring-primary-600 " +
                        "focus:border-primary-600 block w-full shadow-sm text-sm border-blue-gray-300 "
                        + (Icon && "pl-8 ")
                        + (disabled && "disabled:opacity-50")
                    }
                    type={type}
                    id={id}
                    onChange={onChange ? e => onChange((type === "file") ? e.target.files[0] : e.target.value) : null}
                    autoComplete={id}
                    placeholder={placeholder}
                    onKeyPress={onKeyPress ? e => onKeyPress(e.key) : null}
                    value={value}
                    disabled={disabled ? "disabled" : ""}
                />}

            {optional &&
                <div className={"text-xs text-blue-gray-400 w-full text-right mt-0.5 absolute top-16 right-0 pt-1"}>
                    Optional
                </div>
            }

            {subLabel &&
                <div className={"text-xs text-blue-gray-400 w-full text-left mt-0.5 absolute top-16 right-0 pt-1"}>
                    {subLabel}
                </div>
            }

        </div>
    )
}

export default Input;
